(() => {
  const loadOne = (wrap) => {
    if (!wrap) return;
    if (wrap.getAttribute('data-custom') === 'true') return;
    if (wrap.getAttribute('data-loaded') === 'true') return;
    if (wrap.getAttribute('data-idas-related-fetching') === 'true') return;

    const url = wrap.getAttribute('data-url');
    if (!url) return;

    wrap.setAttribute('data-idas-related-fetching', 'true');

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-idas-related]');
        if (!next) return;
        next.setAttribute('data-loaded', 'true');
        wrap.replaceWith(next);
        if (!next.querySelector('.idas-product-card')) {
          const section = next.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
      })
      .catch(() => {
        wrap.removeAttribute('data-idas-related-fetching');
      });
  };

  const load = (root) => {
    (root || document).querySelectorAll('[data-idas-related]').forEach(loadOne);
  };

  document.addEventListener('shopify:section:load', (event) => load(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => load());
  } else {
    load();
  }
})();
